import React from 'react'

const ViewSurveyAssets = () => {
  return (
    <div>ViewSurveyAssets</div>
  )
}

export default ViewSurveyAssets